var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { NgModule } from "@angular/core";
import { HttpModule } from "@angular/http";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { AppComponent } from "./app.component";
import { APP_ROUTING } from "./app.routes";
import { HomeComponent } from "./home/home.component";
import { NavComponent } from "./nav/nav.component";
import { TourOfHeroesModule } from "./subapps/tour-of-heroes/tour-of-heroes.module";
import { GridMemoryComponent } from "./subapps/grid-memory/grid-memory.component";
import { MySpinner } from "./spinner/my-spinner.component";
import { Puzzle2048Component } from "./subapps/2048/puzzle-2048.component";
import { TilesComponent } from "./subapps/2048/tiles.component";
import { HammerGesturesDirective } from "./directives/hammer-gestures.directive";
import { RecognizerComponent } from "./subapps/recognizer/recognizer.component";
export var AppModule = (function () {
    function AppModule() {
    }
    AppModule = __decorate([
        NgModule({
            declarations: [
                AppComponent,
                NavComponent,
                HomeComponent,
                MySpinner,
                HammerGesturesDirective,
                RecognizerComponent,
                GridMemoryComponent,
                Puzzle2048Component,
                TilesComponent],
            imports: [
                HttpModule,
                BrowserModule,
                TourOfHeroesModule,
                APP_ROUTING
            ],
            exports: [RouterModule],
            bootstrap: [AppComponent]
        }), 
        __metadata('design:paramtypes', [])
    ], AppModule);
    return AppModule;
}());
//# sourceMappingURL=app.module.js.map